<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`设备标签打印`"
    width="100vw"
    height="100vh"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset()"
  >
    <div class="flex-table-container">
      <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
        <el-form-item prop="keyword" label="关键词">
          <el-input
            v-model="searchModel.keyword"
            placeholder="请输入名称或编号"
            clearable
            @keyup.enter.native="getTableData(true)"
          ></el-input>
        </el-form-item>
        <el-form-item prop="devType" label="所属分类">
          <el-select v-model="searchModel.devType" placeholder="请选择" clearable @change="getTableData(true)">
            <el-option v-for="item in devTypeOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="state" label="设备状态">
          <el-select v-model="searchModel.state" placeholder="请选择" clearable @change="getTableData(true)">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="form-btn" label-width="0">
          <el-button type="success" @click="getTableData(true)">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="table-main">
        <el-row :gutter="20" type="flex" style="flex-wrap: wrap; height: 100%">
          <el-col :span="18">
            <el-table
              ref="multipleTable"
              :data="tableData"
              row-key="id"
              size="small"
              border
              height="100%"
              v-loading="tableLoading"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55" align="center" reserve-selection></el-table-column>
              <el-table-column label="序号" align="center" width="50">
                <template v-slot="{ $index }">
                  <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="devName" label="设备名称" align="center"></el-table-column>
              <el-table-column prop="devCode" label="管理编号" align="center"></el-table-column>
              <el-table-column prop="devModel" label="型号" align="center"></el-table-column>
              <el-table-column prop="mid" label="出厂编号" align="center"></el-table-column>
              <el-table-column prop="lsCheckTime" label="检定校准日期" align="center"></el-table-column>
              <el-table-column prop="nxCheckTime" label="检定检定校准有效期" align="center"></el-table-column>
              <el-table-column prop="checkOrg" label="校准检定单位" align="center"></el-table-column>
            </el-table>
          </el-col>
          <el-col :span="6">
            <div class="tag-wrap">
              <div class="tag-header">
                当前已选中设备
                <el-button :disabled="tableSelection.length == 0" type="warning" size="mini" @click="handelClear">
                  清空选中
                </el-button>
              </div>
              <div class="tag-body">
                <el-tag :key="item.id" v-for="item in tableSelection" disable-transitions effect="dark">
                  {{ item.devCode }}
                </el-tag>
                <el-empty v-if="tableSelection.length == 0" description="暂无选中设备"></el-empty>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-pagination
          :current-page="searchModel.pageNum"
          :page-size="searchModel.pageSize"
          background
          layout="total, prev,sizes, pager, next, jumper"
          :total="dataTotal"
          :page-sizes="[10, 20, 30, 50]"
          @current-change="onCurrentChange"
          @size-change="onSizeChange"
        ></el-pagination>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <div class="footer-form-item">
        <div class="label">打印份数</div>
        <el-input-number v-model="defaultPrintNumber" :min="1" label="请输入份数" controls-position="right"></el-input-number>
        <div class="label" style="margin-left: 20px">标签模版</div>
        <el-select style="width: 200px" v-model="currentTemplateId" placeholder="请选择">
          <el-option v-for="item in templateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>

      <div>
        <el-button @click="$emit('update:visible', false)">关 闭</el-button>
        <el-button type="primary" @click="handleSubmit">打印</el-button>
      </div>
    </div>
  </drag-dialog>
</template>

<script>
import { hiprint, disAutoConnect } from 'vue-plugin-hiprint';
disAutoConnect(); // 取消打印自动连接客户端打印机

import { getDictsByCode } from '@/api/system';
import { getDeviceList } from '@/api/device';

import { getFormTemplateList } from '@/api/system';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        devType: '',
        keyword: '',
        state: '',
        dateRange: []
      },
      devTypeOptions: [],
      statusOptions: [
        {
          label: '合格',
          value: 1
        },
        {
          label: '停用',
          value: -1
        },
        {
          label: '报废',
          value: -2
        }
      ],
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      tableSelection: [],
      // 标签模版
      currentTemplateId: null,
      templateData: [],
      templateOptions: [],
      defaultPrintNumber: 1,
      hiprintTemplate: null
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val) {
        this.getFormTemplateList();
        this.getDictsByCode('device_type', 'devTypeOptions');
        this.getTableData();
      }
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.tableSelection = val;
    },
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const { data } = await getDeviceList(this.searchModel);
      this.dataTotal = data.count;
      this.tableData = data.list || [];
      this.tableLoading = false;
    },
    async getFormTemplateList() {
      const { data } = await getFormTemplateList({
        pageNum: 1,
        pageSize: 99,
        type: 1
      });

      this.templateData = data.list || [];
      this.templateOptions =
        data?.list?.map(item => ({
          label: item.title,
          value: item.id
        })) || [];

      this.$nextTick(() => {
        const defaultId = data?.list?.find(item => item.isDefault == 1)?.id || data?.list?.[0]?.id || null;
        this.currentTemplateId = defaultId;
      });
    },
    // 打印
    handleSubmit() {
      if (!this.currentTemplateId) return this.$message.warning('请选择打印的标签模版!');
      if (!this.tableSelection.length) return this.$message.warning('请选择要打印的样品!');
      if (this.tableSelection.length * this.defaultPrintNumber > 50)
        return this.$message.warning('数据过多会造成浏览器卡死等问题,最多只能打印50条数据!');

      let printData = [];

      this.tableSelection.forEach(item => {
        for (let index = 0; index < this.defaultPrintNumber; index++) {
          printData.push({
            ...item,
            customCodes: `${item.devCode}/${item.mid ?? ''}`,
            customDeviceUrl: `https://qsjc.dunchong.cc/qsjc/uploadPath/mpdevice?id=${item.id}`
          });
        }
      });

      const templateCode = this.templateData.find(item => item.id === this.currentTemplateId).templateCode;
      const templateJson = JSON.parse(templateCode || '{}');
      hiprint.init();
      this.hiprintTemplate = new hiprint.PrintTemplate({
        template: templateJson
      });

      this.$nextTick(() => {
        this.hiprintTemplate.print(printData);
      });
    },
    handelClear() {
      this.$confirm(`您确认要清空已选中的信息吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$refs.multipleTable.clearSelection();
        })
        .catch(() => {});
    },
    // 获取字典
    async getDictsByCode(code, dataType) {
      const { data } = await getDictsByCode({ code });
      this[dataType] = data;
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-wrap {
  height: 100%;

  .tag-header {
    border-bottom: 1px solid #ebeef5;
    font-size: 14px;
    color: #303133;
    font-weight: 700;
    height: 40px;
    line-height: 40px;
  }
  .tag-body {
    padding: 10px;
    height: calc(100% - 40px);
    overflow: hidden;
    overflow-y: auto;

    .el-tag {
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
  ::v-deep .el-empty {
    height: 100%;
    padding: 0;
  }
}
</style>
